// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var ArrowDashLeft = React.forwardRef(function ArrowDashLeft(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ArrowDashLeft" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.1211 13.2584H19.3139V10.7035H22.1211V13.2584ZM17.2726 13.2555L13.1899 13.2646V10.7131L17.2726 10.704V13.2555ZM2.12109 11.9881L8.82178 4.87891L8.93223 4.87891L9.04269 4.87891L10.6711 6.57638L6.81563 10.709L11.1486 10.709V13.2639L6.82374 13.2639L10.6729 17.308L8.93241 19.1209L2.12109 11.9881Z", fill: "currentColor" }))));
});
ArrowDashLeft.displayName = 'ArrowDashLeft';
export default ArrowDashLeft;
//# sourceMappingURL=ArrowDashLeft.js.map